export enum ProjectConfigurationsKeyNames {
  area = 'area',
  layingType = 'layingType',
  length = 'length',
  width = 'width',
}

export type ProjectConfigurationParameter = {
  key: keyof typeof ProjectConfigurationsKeyNames;
  value: string;
};

export type ProjectConfigurationParameters = Array<ProjectConfigurationParameter>;

export type FetchProjectConfigurationResponse = {
  projectConfigurationParameters: Array<ProjectConfigurationParameter>;
};
